import { TextField } from "@mui/material";

interface AppTextInputProps {
  label?: string;
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
  error?: string;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  fullWidth?: boolean;
  required?: boolean;
}

const AppTextInput = ({
  label,
  value,
  onChange,
  placeholder,
  type = "text",
  error,
  multiline = false,
  rows,
  disabled = false,
  fullWidth = true,
  required = false,
}: AppTextInputProps) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      type={type}
      error={!!error}
      helperText={error}
      multiline={multiline}
      rows={rows}
      disabled={disabled}
      fullWidth={fullWidth}
      required={required}
      size="small"
    />
  );
};

export default AppTextInput;
